<app-nets-payment-declined-modal #netsPaymentDeclinedModal></app-nets-payment-declined-modal>
<app-nets-payment-cancelled-modal #netsPaymentCancelledModal></app-nets-payment-cancelled-modal>
<app-nets-payment-3d-notification-modal #netsPayment3dNotificationModal></app-nets-payment-3d-notification-modal>

<form #terminalForm ngNoForm method="post" [action]="terminalFormAction">
    <input type="hidden" value="" name="merchantId" [ngModel]="merchantId">
    <input type="hidden" value="" name="transactionId" [ngModel]="transactionId">
    <input type="hidden" value="" name="pan" [ngModel]="cardNo">
    <input type="hidden" value="" name="expiryDate" [ngModel]="cardExpiration">
    <input type="hidden" value="" name="securityCode" [ngModel]="cardCvc">
    <!-- <input type="hidden" value="MasterCard" name="payType"> An Experiment that didn't work -->
</form>
